import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useHistory, useParams } from 'react-router-dom'
// @ts-ignore
import { DragDropContainer, DropTarget } from 'react-drag-drop-container'
import { Game7Map, getRndFromArray, useStore, GameStatus, shuffleArray } from '../lib'
import { Guide, Image as Img, Loader, ModalAlert, ModalImage, ScoreStats, SideNav } from '../components'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

export const Game7 = () => {
  const [isInitialized, setIsInitialized] = useState<boolean>(false)
  const [isFinished, setIsFinished] = useState<boolean>(false)
  const [imgWidth, setImgWidth] = useState<number>(window.innerWidth * 0.28)
  const [currentItem, setCurrentItem] = useState<any>(null)
  const [allItems, setAllItems] = useState<any[]>([])
  const [groupA, setGroupA] = useState<any[]>([])
  const [groupB, setGroupB] = useState<any[]>([])
  const [gameStartTime, setGameStartTime] = useState<number>(+new Date())
  const [gameEndTime, setGameEndTime] = useState<number>()
  const history = useHistory()
  const refGuide: any = useRef(null)
  const refModalAlert: any = useRef(null)
  const refModalImage: any = useRef(null)
  // const { id }: any = useParams()
  const { state, patchState } = useStore()

  const preloadImages = async () => {
    const onImgLoad = async (imageEl: HTMLImageElement) => {
      return new Promise(resolve => {
        imageEl.onload = () => resolve(imageEl)
      })
    }
    const all = JSON.parse(JSON.stringify(Game7Map.items))
    const allImgs = [...all].map(a => a.img)
    for (const imgSrc of allImgs) {
      const img = new Image()
      img.src = imgSrc
      await onImgLoad(img)
    }
    const allItemsA = all.filter((i: any) => i.group === 'A')
    const allItemsB = all.filter((i: any) => i.group === 'B')
    const itemsA = getRndFromArray(allItemsA, 5)
    const itemsB = getRndFromArray(allItemsB, 5)
    const a = shuffleArray([...itemsA, ...itemsB])
    setAllItems(a)
    setCurrentItem(getRndFromArray(a))
    setGroupA([])
    setGroupB([])
    setIsInitialized(true)
    return true
  }

  useEffect(() => {
    if (!isInitialized) {
      preloadImages()
      patchState({ score: 0, errors: 0 }) // todo
    } else {
      refGuide?.current?.openModal([...Game7Map.intro])
    }
  }, [isInitialized])

  const decide = (group: 'A' | 'B') => {
    if (currentItem.group === group) {
      patchState({ score: state.score + 1 })
      refGuide?.current?.openModal([currentItem.message])
      const nextGroup = group === 'A' ? [...groupA] : [...groupB]
      nextGroup.push(currentItem)
      group === 'A' ? setGroupA(nextGroup) : setGroupB(nextGroup)
      const nextItems = allItems.filter((a: any) => a.id !== currentItem.id)
      if (nextItems.length === 0) {
        const timeMs = +new Date() - gameStartTime
        patchState({
          timeMs: state.timeMs + timeMs,
          games: { ...state.games, game7: { score: state.score, errors: state.errors, timeMs } },
        })
        setGameEndTime(+new Date())
        refGuide.current?.playSound()
        refGuide?.current?.onGameEnd(state.errors)
        setIsFinished(true)
      } else {
        setCurrentItem(getRndFromArray(nextItems))
      }
      setAllItems(nextItems)
    } else {
      patchState({ errors: state.errors + 1 })
      refGuide?.current?.openModal([getRndFromArray(Game7Map.errorComments, 1)])
    }
  }

  const showItemDetail = (animal: any) => {
    refModalImage?.current?.openModal(animal?.img)
  }

  const exitGame = () => {
    setAllItems([])
    setIsInitialized(false)
    setTimeout(() => history.push('/dashboard'))
  }

  if (!isInitialized) {
    return <Loader />
  }
  return (
    <div className="view background-summer">
      <div className="view-content p-5 text-black">
        <h1 className="text-3xl text-center font-bold w-full">Co do lesa (ne)patří</h1>
        <ScoreStats
          isCompact={true}
          isTimeShown={true}
          startTime={gameStartTime}
          endTime={gameEndTime}
          customScore={state.score}
          customErrors={state.errors}
        />
        <SideNav customScore={state.score} customErrors={state.errors} customText={Game7Map.intro} />
        <Guide ref={refGuide} isWinter={false} hasWinterGearA={true} hasWinterGearB={true} />
        <div className="flex flex-row mt-5" style={{ height: `calc(100% - 1px)`, width: 'calc(100% - 19.25rem)' }}>
          <div className="w-1/3 flex flex-row h-full flex-wrap content-start card glass opacity-90 shadow-xl p-2 pl-5">
            {groupA.map(item => (
              <div className="w-1/3 h-44 pr-5 pb-5 flex items-center justify-center" key={`${item.id}_groupA`}>
                <img
                  className={'img rounded w-auto h-32'}
                  src={item.img}
                  alt={item.label}
                  title={item.label}
                  onClick={() => showItemDetail(item)}
                  draggable={false}
                />
              </div>
            ))}
          </div>
          <div className="w-1/3">
            {isFinished ? (
              <div className="w-full flex flex-col justify-center items-center p-2">
                <div className="card glass p-2">
                  <p className="text-center font-bold ml-16 mr-16">Hotovo!</p>
                  <p className="text-left mt-2 mb-3">
                    Správně {state.score}
                    <br />
                    Chybně {state.errors}
                  </p>
                  <button className="btn btn-primary mt-auto" onClick={() => window.location.reload()}>
                    Hrát znovu
                  </button>
                  <button className="btn btn-primary mt-2" onClick={exitGame}>
                    Zpět na rozcestí
                  </button>
                </div>
              </div>
            ) : (
              <div className="z-50">
                <Img
                  src={currentItem.img}
                  title={''}
                  width={`${imgWidth}px`}
                  scale={0.85}
                  key={`${currentItem.id}_center`}
                  onClick={() => null}
                />
                <div style={{ height: '1px' }}>
                  <button
                    className="btn btn-lg text-black text-2xl glass shadow-xl"
                    style={{ position: 'relative', top: -imgWidth / 1.75, right: imgWidth / 2.75, width: 120 }}
                    onClick={() => decide('A')}
                  >
                    {Game7Map.buttons.groupA}
                  </button>
                  <button
                    className="btn btn-lg text-black text-2xl glass shadow-xl"
                    style={{
                      position: 'relative',
                      top: -imgWidth / 1.75,
                      left: imgWidth / 2.75,
                      width: 120,
                      zIndex: 95,
                    }}
                    onClick={() => decide('B')}
                  >
                    {Game7Map.buttons.groupB}
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="w-1/3 flex flex-row h-full flex-wrap content-start card glass opacity-90 shadow-xl p-2">
            {groupB.map(item => (
              <div className="w-1/3 h-44 pl-5 pb-5 flex items-center justify-center" key={`${item.id}_groupA`}>
                <img
                  className={'img rounded h-32'}
                  src={item.img}
                  alt={item.label}
                  title={item.label}
                  onClick={() => showItemDetail(item)}
                  draggable={false}
                />
              </div>
            ))}
          </div>
        </div>
        <div>
          <ModalAlert ref={refModalAlert} />
        </div>
        <div>
          <ModalImage ref={refModalImage} />
        </div>
      </div>
    </div>
  )
}
